import axios from "axios";
import { getBaseUrlApi, getEnv } from "utils/meta-env";

const BASE_URL_API = getBaseUrlApi() || '';

export const client = axios.create({});

client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.error(`Request failed: ${error}`);
    return Promise.reject(error);
  }
);

// Manifest cache - stores version once loaded
let manifestCache = null;

// Fetch and cache the manifest to discover versioned data paths
const getManifest = async () => {
  if (manifestCache) {
    return manifestCache;
  }

  const response = await client.get('/data/manifest.json');
  manifestCache = response.data;
  return manifestCache;
};

// Construct versioned data path using manifest version
const getDataPath = async (path) => {
  const manifest = await getManifest();
  return `/data/${manifest.version}${path}`;
};

export default {
  schools: {
    async get(id) {
      if (id) {
        const path = await getDataPath(`/schools/${id}.json`);
        return client.get(path);
      }

      const path = await getDataPath('/schools.json');
      return client.get(path);
    }
  },
  polygons: {
    async get() {
      const path = await getDataPath('/polygons.json');
      return client.get(path);
    }
  },
  activities: {
    async get() {
      const path = await getDataPath('/activities.json');
      return client.get(path);
    }
  },
  logSearch(params) {
    if (getEnv() === "development") {
      return Promise.resolve()
    }

    return client.post(`${BASE_URL_API}/school_locator/search_logs`, {
      ...params
    });
  },
  emailList(params) {
    return client.post(`${BASE_URL_API}/school_locator/email_lists`, params)
  }
};
